import React from 'react'
import './style.css'
import MenuD from './MenuD'
import MenuM from './MenuM'


const Menu = (props) => {

    return (
        
        <React.Fragment>
            
            { props.isMobile ? <MenuM /> : <MenuD /> }
        
        </React.Fragment>
    )
}

export default Menu

   


// WEBPACK FOOTER //
// ./src/components/menu/index.js